import { db } from '../firebase';
import { collection, doc, getDocs, setDoc, deleteDoc, query } from 'firebase/firestore';

export interface RolePercentage {
  id: string;
  role: string;
  percentage: number;
  tenantId: string;
  isEligible?: boolean; // If false, this role is excluded from tip allocations
}

export const getRolePercentages = async (tenantId: string): Promise<RolePercentage[]> => {
  const rolesRef = collection(db, 'tenants', tenantId, 'role_percentages');
  const q = query(rolesRef);
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    isEligible: true, // Default to true if not present
    ...doc.data()
  } as RolePercentage));
};

export const saveRolePercentages = async (tenantId: string, roles: RolePercentage[]) => {
  for (const role of roles) {
    const sanitizedId = (role.id || role.role).replace(/\//g, '_');
    const roleRef = doc(db, 'tenants', tenantId, 'role_percentages', sanitizedId);
    await setDoc(roleRef, {
      role: role.role,
      percentage: role.percentage,
      isEligible: role.isEligible ?? true,
      tenantId
    });
  }
};

export const deleteRolePercentage = async (tenantId: string, roleId: string): Promise<void> => {
  const sanitizedId = roleId.replace(/\//g, '_');
  const roleRef = doc(db, 'tenants', tenantId, 'role_percentages', sanitizedId);
  await deleteDoc(roleRef);
};
